<template>
  <component :is="advancePaymentData === undefined ? 'div' : 'b-card'">
    <b-alert variant="danger" :show="advancePaymentData === undefined">
      <h4 class="alert-heading">獲取預支數據時出錯</h4>
      <div class="alert-body">
        找不到相關預支記錄。請查看
        <b-link class="alert-link" :to="{ name: 'advance-payment-list' }">
          預支列表
        </b-link>
      </div>
    </b-alert>
    <advance-payment-edit-tab-information
      v-if="advancePaymentData"
      :userOptions="userOptions"
      :advance-payment-data="advancePaymentData"
      :receiveMethodOptions="receiveMethodOptions"
      :salaryReceiveMethodOptions="receiveMethodOptions"
      :prepaymentStatusOptions="prepaymentStatusOptions"
      :invoiceOptions="invoiceOptions"
      :is_user_page="is_user_page"
      :role="role"
      @refetch-data="refetchData"
      class="p-sm-2"
    />
  </component>
</template>

<script>
import { BCard, BAlert, BLink, BTabs, BTab } from "bootstrap-vue";
import { ref, onUnmounted, onMounted } from "@vue/composition-api";
import store from "@/store";
import router from "@/router";
import advancePaymentStoreModule from "../advancePaymentStoreModule";
import advancePaymentEditTabInformation from "./advancePaymentEditTabInformation.vue";

export default {
  components: {
    advancePaymentEditTabInformation,
    BCard,
    BAlert,
    BTabs,
    BTab,
    BLink,
  },
  data() {
    return {};
  },
  setup() {
    const advancePaymentData = ref({
      id: 0,
      total_amount: null,
      user_id: null,
      project_id: null,
      received_amount: null,
      used_amount: null,
      pending_amount: null,
      rejected_amount: null,
      refunded_amount: null,
      balance: null,
      salary_type: null,
      salary_records:[{id:0}],
      salary_year: null,
      salary_month: null,
      receive_method_id: null,
      receipt_date: null,
      check_number: null,
      prepayment_status_id: 1,
      transactions: [
        { id: 0,
          create_id: null,
          user_id: null,
          amount: 0,
          prepayment_id: null,
          description: null,
          is_approved: 0,
          is_rejected: 0,
          admin_remark: null,
          approve_date: null
          // 移除了以下字段，現在由主表層級管理：
          // is_received, receive_date, receive_method_id, check_number
        },
      ],
    });
    const advance_payment = {
      id: 0,
      total_amount: null,
      user_id: null,
      project_id: null,
      received_amount: null,
      used_amount: null,
      pending_amount: null,
      rejected_amount: null,
      refunded_amount: null,
      balance: null,
      salary_records:[],
      transactions:[],
      order_number: 0,
      requires_invoice: 0, 
      salary_type: null,
      salary_records:[{id:0}],
      salary_year: null,
      salary_month: null,
      receive_method_id: null,
      receipt_date: null,
      check_number: null,
      prepayment_status_id: 1,
      // salary_records: [
      //   { 
            // id: 0,
            // is_monthly: 0,
            // user_id: null,
            // working_days: 0,
            // day_salary: 0,
            // total_salary: 0,
            // working_date: "",
            // year_month: "",
            // salary_year: "",
            // salary_month: "",
            // remark: "",
            // is_approved: 0,
            // approve_remark: "",
            // approve_date: "",
      //   },
      // ],
      // expense_items: [
      //   { id: 0, 
      //     product_category_id: null, 
      //     product_id: null, 
      //     remark: null, 
      //     quantity: 0,
      //     unit_price: 0,
      //     amount: 0,
      //     is_approved: 0,
      //     approve_remark: null,
      //     approve_date: null,
      //   },
      // ],
      // transactions: [
      //   { 
      //     id: 0, 
      //     is_received: 0, 
      //     create_id: null, 
      //     user_id: null, 
      //     amount: 0, 
      //     prepayment_id: null,
      //     receive_date: null,
      //     description: null, 
      //     receive_method_id: null, 
      //     receive_method_name: null 
      //   },
      // ],
    };

    const advance_payment_APP_STORE_MODULE_NAME = "advance-payment";

    if (!store.hasModule(advance_payment_APP_STORE_MODULE_NAME))
      store.registerModule(
        advance_payment_APP_STORE_MODULE_NAME,
        advancePaymentStoreModule
      );

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(advance_payment_APP_STORE_MODULE_NAME))
        store.unregisterModule(advance_payment_APP_STORE_MODULE_NAME);
    });

    const role = ref(null);
    const init = ref(true);
    const refetchData = () => {
      if (router.currentRoute.name.indexOf("create") > -1) {
        advancePaymentData.value = advance_payment;
        if(init.value){
          if (router.currentRoute.query.user_id) {
            advancePaymentData.value.user_id = Number(
              router.currentRoute.query.user_id
            );
          }
          
          init.value = false
        }
      } else {
        store
          .dispatch("advance-payment/fetchAdvancePayment", {
            id: router.currentRoute.params.id,
          })
          .then((response) => {
            advancePaymentData.value = response.data.prepayment;
           

            // 處理薪資記錄的年月設置
            if (advancePaymentData.value.salary_records && advancePaymentData.value.salary_records.length > 0) {
              advancePaymentData.value.salary_records.forEach((item) => {
                if (advancePaymentData.value.salary_year && advancePaymentData.value.salary_month) {
                  item.year_month = new Date(`${advancePaymentData.value.salary_year}-${advancePaymentData.value.salary_month}-01`);
                }
                // 編輯模式下不處理 salary_type，保持原有值
                // salary_type 應該在創建預支記錄時就被固定保存
              });
            }
          })
          .catch((error) => {
            console.log("error when fetching advance payment", error);
            if (error.response.status === 404) {
              advancePaymentData.value = undefined;
            }
          });
      }
    };

    const userOptions = ref([]);
    const receiveMethodOptions = ref([]);
    const prepaymentStatusOptions = ref([]);
    const invoiceOptions = ref([]);

    const refetchOption = () => {
      store
        .dispatch("app/fetchOptionList", {
          users: true,
          receive_methods: true,
          prepayment_statuses: true,
          invoices: true,
        })
        .then((response) => {
          // 使用 userOptions 過濾出員工 (user_type_id = 1) 和師傅 (user_type_id = 4)
          userOptions.value = response.data.users.filter(user => user.user_type_id == 1 || user.user_type_id == 4);
          receiveMethodOptions.value = response.data.receive_methods.filter(ele=> ele.id!=18).sort ((a, b) => a.sort_order - b.sort_order);
          prepaymentStatusOptions.value = response.data.prepayment_statuses;
          invoiceOptions.value = response.data.invoices;
          refetchData();
        });
    };


    const is_user_page = ref(false);
    onMounted(() => {
      refetchOption();
      role.value = JSON.parse(localStorage.getItem("userData")).role;
      if (router.currentRoute.name.indexOf("worker") > -1) {
        is_user_page.value = true;
      }
    });

    return {
      advancePaymentData,
      refetchData,
      userOptions,
      receiveMethodOptions,
      prepaymentStatusOptions,
      invoiceOptions,
      is_user_page,
      role,
    };
  },
};
</script>
